module.exports = __webpack_public_path__ + "static/TiemposHeadlineWeb-Semibold-087c7ecdb985dd6eb5b334923b8be361.woff2";